import React, { Component } from "react";
import HorarioBox from "./horarioBox";
import "./horarios.css";

class Horarios extends Component {
  render() {
    return (
      <div>
        {/* Lunes, Miércoles y Viernes */}
        <div className="prices-init content content-center" id="Horarios">
          <div className="container">
            <h2>
              <strong>Horario para: Lunes, Miércoles y Viernes</strong>
            </h2>
            <div className="row justify-content-center">
              {/* Niños */}
              <HorarioBox
                title="Kung Fu Niños"
                days="Lunes - Miércoles - Viernes"
                from="5:00 pm"
                to="6:00 pm"
                target="Dirigido a Niños"
              />
              {/* Jóvenes y Adultos */}
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Lunes - Miércoles - Viernes"
                from="8:00 am"
                to="9:00 am"
                target="Dirigido a Jóvenes y Adultos"
              />
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Lunes - Miércoles - Viernes"
                from="5:00 pm"
                to="6:00 pm"
                target="Dirigido a Jóvenes y Adultos"
              />
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Lunes - Miércoles - Viernes"
                from="6:10 pm"
                to="7:10 pm"
                target="Dirigido a Jóvenes y Adultos"
              />
            </div>
          </div>
        </div>

        {/* Martes y Jueves */}
        <div className="prices-block content content-center" id="Horarios">
          <div className="container">
            <h2>
              <strong>Horario para: Martes y Jueves</strong>
            </h2>
            <div className="row justify-content-center">
              {/* Niños */}
              <HorarioBox
                title="Kung Fu Niños"
                days="Martes - Jueves"
                from="5:00 pm"
                to="6:00 pm"
                target="Dirigido a Niños"
              />
              {/* Jóvenes y Adultos */}
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Martes - Jueves"
                from="5:00 pm"
                to="6:00 pm"
                target="Dirigido a Jóvenes y Adultos"
              />
            </div>
          </div>
        </div>

        {/* Sábados */}
        <div className="prices-block content content-center" id="Horarios">
          <div className="container">
            <h2>
              <strong>Horario para: Sábados</strong>
            </h2>
            <div className="row justify-content-center">
              {/* Niños */}
              <HorarioBox
                title="Kung Fu Niños"
                days="Sábados"
                from="8:30 am"
                to="9:30 am"
                target="Dirigido a Niños"
              />
              <HorarioBox
                title="Kung Fu Niños"
                days="Sábados"
                from="10:00 am"
                to="11:00 am"
                target="Dirigido a Niños"
              />
              {/* Jóvenes y Adultos */}
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Sábados"
                from="8:30 am"
                to="9:30 am"
                target="Dirigido a Jóvenes y Adultos"
              />
              <HorarioBox
                title="Kung Fu Jóvenes y Adultos"
                days="Sábados"
                from="10:00 am"
                to="11:00 am"
                target="Dirigido a Jóvenes y Adultos"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Horarios;
